import { render, staticRenderFns } from "./InvalidForm.vue?vue&type=template&id=2be13093&scoped=true&"
import script from "./InvalidForm.vue?vue&type=script&lang=js&"
export * from "./InvalidForm.vue?vue&type=script&lang=js&"
import style0 from "./InvalidForm.vue?vue&type=style&index=0&id=2be13093&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be13093",
  null
  
)

export default component.exports